import React from "react";
import { Layout, Menu, Space, Tooltip, Dropdown } from "antd";
import { NavLink, useLocation, Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import signout from "../../img/signout.svg";
import AuthService from "../../services/AuthService";
import LocalStorageService from "../../services/LocalStorageService";
import { hasAccess } from "../RolesModule/hasAccess";
import {
  MENU_ACCOUNTS_INDIVIDUAL,
  MENU_ACCOUNTS_INDIVIDUAL_WRITE,
  MENU_ACCOUNTS,
  MENU_ACCOUNTS_WRITE,
  MENU_ACCOUNTS_ORGANIZATION,
  MENU_ACCOUNTS_ORGANIZATION_WRITE,
  MENU_ADMIN_DIC,
  MENU_ADMIN_DIC_WRITE,
  MENU_ADMIN_EXCHANGE,
  MENU_ADMIN_EXCHANGE_WRITE,
  MENU_ADMIN_PROPERTY_TYPE,
  MENU_ADMIN_PROPERTY_TYPE_WRITE,
  MENU_ADMIN_SERVICEBILLINGPROFILE,
  MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE,
  MENU_ADMIN_SERVICETYPE,
  MENU_ADMIN_SERVICETYPE_WRITE,
  MENU_ADMIN_TENANT,
  MENU_ADMIN_TENANT_WRITE,
  MENU_BILLING_ACCOUNTINGSYSTEM,
  MENU_BILLING_ACCOUNTINGSYSTEM_WRITE,
  MENU_BILLING_BILLINGPROCEDURES,
  MENU_BILLING_BILLINGPROCEDURES_WRITE,
  MENU_BILLING_PREPAYMENTBILL,
  MENU_BILLING_PREPAYMENTBILL_WRITE,
  MENU_BILLING_TRAFFIC,
  MENU_BILLING_TRAFFIC_WRITE,
  MENU_BILLS,
  MENU_BILLS_WRITE,
  MENU_CHARGES,
  MENU_CHARGES_WRITE,
  MENU_PAYMENTLOAD,
  MENU_PAYMENTLOAD_WRITE,
  MENU_PAYMENTS,
  MENU_PAYMENTS_WRITE,
  MENU_SERVICES,
  MENU_SERVICES_WRITE,
  MENU_TASKMANAGER,
  MENU_TASKMANAGER_WRITE,
  MENU_USER_HELP,
  MENU_USER_HELP_WRITE,
  MENU_USER_USERALERTS,
  MENU_USER_USERALERTS_WRITE,
  MENU_USER_USERMANAGEMENT,
  MENU_USER_USERMANAGEMENT_WRITE,
  MENU_BILLING_ROLLBACK,
  MENU_BILLING_ROLLBACK_WRITE,
  MENU_ADMIN_INFOTEMPLATE,
  MENU_ADMIN_INFOTEMPLATE_WRITE,
  MENU_ADMIN_OFFERING,
  MENU_ADMIN_OFFERING_WRITE,
  MENU_TC_ADMIN_DESTINATIONS_WRITE,
  MENU_TC_ADMIN_DESTINATIONS,
  MENU_TC_ROUTING_ORDERS,
  MENU_TC_ROUTING_ORDERS_WRITE,
  MENU_TC_ROUTING_ROUTING_PLAN,
  MENU_TC_ROUTING_ROUTING_PLAN_WRITE,
  MENU_ADMIN_BLOCKING_TYPE,
  MENU_ADMIN_BLOCKING_TYPE_WRITE,
  MENU_ADMIN_OFFERING_POLICY,
  MENU_ADMIN_OFFERING_POLICY_WRITE,
  MENU_ADMIN_OFFERING_GROUP_WRITE,
  MENU_ADMIN_OFFERING_GROUP,
  MENU_ADMIN_CHAR_TYPE_WRITE,
  MENU_ADMIN_CHAR_TYPE,
  MENU_ADMIN_OBJECT_CHAR_TYPE,
  MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE,
  MENU_ADMIN_REPORT_TEMPLATE_READ,
  MENU_ADMIN_REPORT_TEMPLATE,
  MENU_ADMIN_FLEX_ENTITY,
  MENU_ADMIN_FLEX_USEROBJECT,
  MENU_REPORTS,
  MENU_REPORTS_WRITE,
  BILLING_ACCOUNTING_SYSTEM_EXPORT,
  BILLING_ACCOUNTING_SYSTEM_TASKS,
  BILLING_ACCOUNTING_SYSTEM_PROCEDURES,
  BILLING_ACCOUNTING_SYSTEM_EXTNUM,
} from "../../lib/const/permissions";
import { handleCheckUrlForRemovingChargeSessionStorage } from "../../store/slices/charges";
import featuresToggle from "../../lib/utils/featuresToggle";
import Logo from "../Logo/Logo";
import { baseUrlName } from "../../lib/routes/baseUrl";
import { hasLocalAccess } from "../../lib/configs";
import useBlockingMode from "../../lib/hooks/useBlockingMode";
import "./Navbar.less";

const { Header } = Layout;
const { SubMenu } = Menu;

const styles = {
  layout: {
    backgroundColor: "white",
    position: "sticky",
    top: "0",
    zIndex: "1",
    marginBottom: "16px",
  },
  headerContainer: {
    padding: "0",
    height: "48px",
    backgroundColor: "white",
    margin: "0 20px",
    minWidth: "1240px",
  },
  menu: {
    lineHeight: "48px",
    height: "49px",
    display: "flex",
    margin: "0",
    padding: "0",
  },
  menuItem: { width: "fitContent", textAlign: "center", padding: "0 15px" },
  tenantMenuItem: {
    width: "fitContent",
    textAlign: "center",
    padding: "0 15px",
  },
  tenantName: { color: "#8A99A8", textTransform: "uppercase" },
  userName: { color: "black" },
};

export default function Navbar() {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const activeKey = pathname.split("/").filter(Boolean).join("/");
  const userName = jwtDecode(AuthService.getCurrentUser());
  const isBlockingMode = useBlockingMode();

  const handleCheckActiveKey = (e) => {
    dispatch(handleCheckUrlForRemovingChargeSessionStorage({ url: `${e.key}main-menu` }));
  };

  const handleLogout = () => {
    LocalStorageService.clearToken();
    window.location.reload();
  };

  const menuDropdown = () => (
    <Menu>
      {hasAccess(MENU_USER_USERMANAGEMENT, MENU_USER_USERMANAGEMENT_WRITE) &&
        hasLocalAccess("feature.roles") && (
          <Menu.Item className="navbar-dropdown_item">
            <Link className="navbar-dropdown_link navbar-dropdown_link-roles" to="/roles">
              Управление
            </Link>
          </Menu.Item>
        )}
      {/* {hasAccess(MENU_USER_USERALERTS, MENU_USER_USERALERTS_WRITE) &&
        hasLocalAccess("feature.notifications") && (
          <Menu.Item className="navbar-dropdown_item">
            <Link
              className="navbar-dropdown_link navbar-dropdown_link-notifications"
              to="/notifications"
            >
              Оповещения
            </Link>
          </Menu.Item>
        )} */}
      {/* {hasAccess(MENU_USER_HELP, MENU_USER_HELP_WRITE) && hasLocalAccess("feature.help") && (
        <Menu.Item className="navbar-dropdown_item">
          <Link className="navbar-dropdown_link navbar-dropdown_link-help" to="/help">
            Помощь
          </Link>
        </Menu.Item>
      )} */}
    </Menu>
  );

  const hasAccessAllAccounts =
    hasAccess(
      MENU_ACCOUNTS,
      MENU_ACCOUNTS_WRITE,
      MENU_ACCOUNTS_ORGANIZATION,
      MENU_ACCOUNTS_ORGANIZATION_WRITE
    ) && hasAccess(MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE);

  const hasAccessOnlyOrganization =
    hasAccess(
      MENU_ACCOUNTS,
      MENU_ACCOUNTS_WRITE,
      MENU_ACCOUNTS_ORGANIZATION,
      MENU_ACCOUNTS_ORGANIZATION_WRITE
    ) && !hasAccess(MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE);

  const hasAccessOnlyIndividual =
    !hasAccess(
      MENU_ACCOUNTS,
      MENU_ACCOUNTS_WRITE,
      MENU_ACCOUNTS_ORGANIZATION,
      MENU_ACCOUNTS_ORGANIZATION_WRITE
    ) && hasAccess(MENU_ACCOUNTS_INDIVIDUAL, MENU_ACCOUNTS_INDIVIDUAL_WRITE);

  const isAccountsIndividualAvailable = featuresToggle({
    value: true,
    alternativeValue: false,
    condition: hasLocalAccess("feature.accounts/individual"),
  });

  const serviceTitle = React.useMemo(() => {
    switch (baseUrlName) {
      case "numericIds":
      default:
        return "Продукты";
    }
  }, [baseUrlName]);

  const serviceTitleAdmin = React.useMemo(() => {
    switch (baseUrlName) {
      case "numericIds":
      default:
        return "Типы продуктов";
    }
  }, [baseUrlName]);

  const showBlockingTypesMenu =
    isBlockingMode && hasAccess(MENU_ADMIN_BLOCKING_TYPE, MENU_ADMIN_BLOCKING_TYPE_WRITE);

  return (
    <Layout style={styles.layout}>
      <Header style={styles.headerContainer}>
        <Logo />
        <Menu
          theme="light"
          className="navbar"
          mode="horizontal"
          style={styles.menu}
          onClick={handleCheckActiveKey}
          selectedKeys={[activeKey]}
        >
          {hasAccessAllAccounts && isAccountsIndividualAvailable && (
            <SubMenu style={styles.menuItem} key="subMenu-accounts" icon="" title="Аккаунты">
              <Menu.Item className="navbar-submenu" key="accounts/list">
                <NavLink className="menu__textItem" to="/accounts/list">
                  Юридические лица
                </NavLink>
              </Menu.Item>
              <Menu.Item className="navbar-submenu" key="accounts/individual">
                <NavLink className="menu__textItem" to="/accounts/individual">
                  Физические лица
                </NavLink>
              </Menu.Item>
            </SubMenu>
          )}
          {hasAccessAllAccounts && !isAccountsIndividualAvailable && (
            <Menu.Item className="navbar-submenu" key="accounts/list">
              <NavLink className="menu__textItem" to="/accounts/list">
                Аккаунты
              </NavLink>
            </Menu.Item>
          )}
          {hasAccessOnlyOrganization && hasLocalAccess("feature.accounts/list") && (
            <Menu.Item className="navbar-submenu" key="accounts/list">
              <NavLink className="menu__textItem" to="/accounts/list">
                Аккаунты
              </NavLink>
            </Menu.Item>
          )}
          {hasAccessOnlyIndividual && isAccountsIndividualAvailable && (
            <Menu.Item className="navbar-submenu" key="accounts/individual">
              <NavLink className="menu__textItem" to="/accounts/individual">
                Аккаунты
              </NavLink>
            </Menu.Item>
          )}
          {hasAccess(MENU_PAYMENTLOAD, MENU_PAYMENTLOAD_WRITE) && (
            <Menu.Item style={styles.menuItem} key="statements">
              <NavLink to="/statements">Выписки</NavLink>
            </Menu.Item>
          )}
          {hasAccess(MENU_BILLS, MENU_BILLS_WRITE) && (
            <Menu.Item style={styles.menuItem} key="bills">
              <NavLink to="/bills">Счета</NavLink>
            </Menu.Item>
          )}
          {hasAccess(MENU_PAYMENTS, MENU_PAYMENTS_WRITE) && (
            <Menu.Item style={styles.menuItem} key="payments">
              <NavLink to="/payments">Платежи</NavLink>
            </Menu.Item>
          )}
          {hasAccess(MENU_CHARGES, MENU_CHARGES_WRITE) && (
            <Menu.Item style={styles.menuItem} key="charges">
              <NavLink to="/charges">Начисления</NavLink>
            </Menu.Item>
          )}
          {hasAccess(MENU_SERVICES, MENU_SERVICES_WRITE) && (
            <Menu.Item style={styles.menuItem} key="services">
              <NavLink to="/services">{serviceTitle}</NavLink>
            </Menu.Item>
          )}
          {hasAccess(
            MENU_ADMIN_OFFERING_POLICY,
            MENU_ADMIN_OFFERING_POLICY_WRITE,
            MENU_ADMIN_OFFERING,
            MENU_ADMIN_OFFERING_WRITE,
            MENU_ADMIN_OFFERING_GROUP,
            MENU_ADMIN_OFFERING_GROUP_WRITE
          ) && (
              <SubMenu style={styles.menuItem} key="subMenu-offering" icon="" title="Предложения">
                {hasAccess(MENU_ADMIN_OFFERING, MENU_ADMIN_OFFERING_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="offer/list">
                    <NavLink className="menu__textItem" to="/offer/list">
                      Предложения
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_OFFERING_POLICY, MENU_ADMIN_OFFERING_POLICY_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="policies">
                    <NavLink className="menu__textItem" to="/policies">
                      Политики
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_OFFERING_GROUP, MENU_ADMIN_OFFERING_GROUP_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="offering-groups">
                    <NavLink className="menu__textItem" to="/offering-groups">
                      Группы предложений
                    </NavLink>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
          {hasAccess(MENU_TASKMANAGER, MENU_TASKMANAGER_WRITE) && (
            <Menu.Item style={styles.menuItem} key="tasks">
              <NavLink to="/tasks">Задания</NavLink>
            </Menu.Item>
          )}
          {hasAccess(
            MENU_BILLING_TRAFFIC,
            MENU_BILLING_TRAFFIC_WRITE,
            MENU_BILLING_ACCOUNTINGSYSTEM,
            MENU_BILLING_ACCOUNTINGSYSTEM_WRITE,
            MENU_BILLING_PREPAYMENTBILL,
            MENU_BILLING_PREPAYMENTBILL_WRITE,
            MENU_BILLING_BILLINGPROCEDURES,
            MENU_BILLING_BILLINGPROCEDURES_WRITE,
            MENU_BILLING_ROLLBACK,
            MENU_BILLING_ROLLBACK_WRITE
          ) && (
              <SubMenu style={styles.menuItem} key="subMenu" icon="" title="Биллинг">
                {hasAccess(MENU_BILLING_TRAFFIC, MENU_BILLING_TRAFFIC_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="rejected-traffic">
                    <NavLink className="menu__textItem" to="/rejected-traffic">
                      Трафик
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_BILLING_ACCOUNTINGSYSTEM, MENU_BILLING_ACCOUNTINGSYSTEM_WRITE) &&
                  hasAccess(
                    BILLING_ACCOUNTING_SYSTEM_EXPORT,
                    BILLING_ACCOUNTING_SYSTEM_TASKS,
                    BILLING_ACCOUNTING_SYSTEM_PROCEDURES,
                    BILLING_ACCOUNTING_SYSTEM_EXTNUM) && (
                    <Menu.Item className="navbar-submenu" key="counting-department">
                      <NavLink className="menu__textItem" to="/counting-department">
                        Выгрузка в бухгалтерию
                      </NavLink>
                    </Menu.Item>
                  )}
                {hasAccess(MENU_BILLING_PREPAYMENTBILL, MENU_BILLING_PREPAYMENTBILL_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="bills-prepayments">
                    <NavLink className="menu__textItem" to="/bills-prepayments">
                      Счета на предоплату
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_BILLING_BILLINGPROCEDURES, MENU_BILLING_BILLINGPROCEDURES_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="closed-documents">
                    <NavLink className="menu__textItem" to="/closed-documents">
                      Формирование закрывающих документов
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_BILLING_ROLLBACK, MENU_BILLING_ROLLBACK_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="billing-rollback">
                    <NavLink className="menu__textItem" to="/billing-rollback">
                      Откат биллинга
                    </NavLink>
                  </Menu.Item>
                )}
              </SubMenu>
            )}
          {(hasAccess(
            MENU_ADMIN_EXCHANGE,
            MENU_ADMIN_EXCHANGE_WRITE,
            MENU_ADMIN_DIC,
            MENU_ADMIN_DIC_WRITE,
            MENU_ADMIN_SERVICEBILLINGPROFILE,
            MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE,
            MENU_ADMIN_SERVICETYPE,
            MENU_ADMIN_SERVICETYPE_WRITE,
            MENU_ADMIN_TENANT,
            MENU_ADMIN_TENANT_WRITE,
            MENU_ADMIN_PROPERTY_TYPE,
            MENU_ADMIN_PROPERTY_TYPE_WRITE,
            MENU_ADMIN_INFOTEMPLATE,
            MENU_ADMIN_INFOTEMPLATE_WRITE,
            MENU_ADMIN_REPORT_TEMPLATE_READ,
            MENU_ADMIN_REPORT_TEMPLATE,
            MENU_TC_ADMIN_DESTINATIONS,
            MENU_TC_ADMIN_DESTINATIONS_WRITE,
            MENU_ADMIN_CHAR_TYPE,
            MENU_ADMIN_CHAR_TYPE_WRITE,
            MENU_ADMIN_OBJECT_CHAR_TYPE,
            MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE,
            MENU_ADMIN_FLEX_ENTITY,
            MENU_ADMIN_FLEX_USEROBJECT
          ) ||
            showBlockingTypesMenu) && (
              <SubMenu style={styles.menuItem} key="subMenu-admin" icon="" title="Администрирование">
                {hasAccess(MENU_ADMIN_EXCHANGE, MENU_ADMIN_EXCHANGE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="currencies">
                    <NavLink className="menu__textItem" to="/currencies">
                      Курсы валют
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_DIC, MENU_ADMIN_DIC_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="dictionaries">
                    <NavLink className="menu__textItem" to="/dictionaries">
                      Справочники
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(
                  MENU_ADMIN_SERVICEBILLINGPROFILE,
                  MENU_ADMIN_SERVICEBILLINGPROFILE_WRITE
                ) && (
                    <Menu.Item className="navbar-submenu" key="service-profile">
                      <NavLink className="menu__textItem" to="/service-profile">
                        Профиль оплаты
                      </NavLink>
                    </Menu.Item>
                  )}
                {hasAccess(MENU_ADMIN_SERVICETYPE, MENU_ADMIN_SERVICETYPE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="service-types">
                    <NavLink className="menu__textItem" to="/service-types">
                      {serviceTitleAdmin}
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_INFOTEMPLATE, MENU_ADMIN_INFOTEMPLATE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="templates">
                    <NavLink className="menu__textItem" to="/templates">
                      Шаблоны писем
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_PROPERTY_TYPE, MENU_ADMIN_PROPERTY_TYPE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="property-types">
                    <NavLink className="menu__textItem" to="/property-types">
                      Типы свойств
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_TENANT, MENU_ADMIN_TENANT_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="tenants">
                    <NavLink className="menu__textItem" to="/tenants">
                      Тенант
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_REPORT_TEMPLATE_READ, MENU_ADMIN_REPORT_TEMPLATE) && (
                  <Menu.Item className="navbar-submenu" key="document-templates">
                    <NavLink className="menu__textItem" to="/document-templates">
                      Шаблоны документов
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_TC_ADMIN_DESTINATIONS, MENU_TC_ADMIN_DESTINATIONS_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="destinations">
                    <NavLink className="menu__textItem" to="/destinations">
                      Направления
                    </NavLink>
                  </Menu.Item>
                )}
                {showBlockingTypesMenu && (
                  <Menu.Item className="navbar-submenu" key="blocking-types">
                    <NavLink className="menu__textItem" to="/blocking-types">
                      Типы блокировок
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_CHAR_TYPE, MENU_ADMIN_CHAR_TYPE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="types-characteristics">
                    <NavLink className="menu__textItem" to="/types-characteristics">
                      Типы характеристик
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_OBJECT_CHAR_TYPE, MENU_ADMIN_OBJECT_CHAR_TYPE_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="types-characteristics-object">
                    <NavLink className="menu__textItem" to="/types-characteristics-object">
                      Типы характеристик (объект)
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_FLEX_ENTITY) && (
                  <Menu.Item className="navbar-submenu" key="entitypc-admin-entity">
                    <Link
                      className="menu__textItem"
                      onClick={() => (window.location.href = "/entitypc/admin/entity/")}
                    >
                      Сущности
                    </Link>
                  </Menu.Item>
                )}
                {hasAccess(MENU_ADMIN_FLEX_USEROBJECT) && (
                  <Menu.Item className="navbar-submenu" key="entitypc-dic">
                    <Link
                      className="menu__textItem"
                      onClick={() => (window.location.href = "/entitypc/dic/")}
                    >
                      Пользовательские объекты
                    </Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

          {hasAccess(
            MENU_TC_ROUTING_ORDERS,
            MENU_TC_ROUTING_ORDERS_WRITE,
            MENU_TC_ROUTING_ROUTING_PLAN,
            MENU_TC_ROUTING_ROUTING_PLAN_WRITE
          ) && (
              <SubMenu
                style={styles.menuItem}
                key="subMenu-routing-plan"
                icon=""
                title="Маршрутизация"
              >
                {hasAccess(MENU_TC_ROUTING_ORDERS, MENU_TC_ROUTING_ORDERS_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="routing-orders">
                    <NavLink className="menu__textItem" to="/routing-orders">
                      Список заказов
                    </NavLink>
                  </Menu.Item>
                )}
                {hasAccess(MENU_TC_ROUTING_ROUTING_PLAN, MENU_TC_ROUTING_ROUTING_PLAN_WRITE) && (
                  <Menu.Item className="navbar-submenu" key="routing-plans">
                    <NavLink className="menu__textItem" to="/routing-plans">
                      План маршрутизации
                    </NavLink>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

          {hasAccess(MENU_REPORTS, MENU_REPORTS_WRITE) && (
            <Menu.Item style={styles.menuItem} key="reports">
              <NavLink to="/reports">Отчёты</NavLink>
            </Menu.Item>
          )}

          <Menu.Item
            disabled
            className="navbar__menu-item_disabled"
            key="userName"
            style={{ marginLeft: "auto" }}
          >
            {hasAccess(
              MENU_USER_USERMANAGEMENT,
              MENU_USER_USERMANAGEMENT_WRITE,
              MENU_USER_USERALERTS,
              MENU_USER_USERALERTS_WRITE,
              MENU_USER_HELP,
              MENU_USER_HELP_WRITE
            ) ? (
              <Dropdown className="navbar-dropdown" overlay={menuDropdown} trigger={["click"]}>
                <span style={styles.userName}>
                  {userName.display_name}
                  <DownOutlined className="navbar-dropdown_icon" />
                </span>
              </Dropdown>
            ) : (
              userName.display_name
            )}
          </Menu.Item>
          <Menu.Item
            key="tenantName"
            style={styles.tenantMenuItem}
            disabled
            className="navbar__menu-item_disabled"
          >
            <span style={styles.tenantName}>{LocalStorageService.getTenantName()}</span>
          </Menu.Item>
          <Menu.Item style={styles.menuItem} key="logout" onClick={handleLogout}>
            <Tooltip title="Выйти">
              <img src={signout} alt="Выход" />
            </Tooltip>
          </Menu.Item>
        </Menu>
        <Space size="large" className="build-info">
          <pre>{process.env.REACT_APP_GIT_SHA || "commit"}</pre>
          <pre>{process.env.REACT_APP_GIT_MESSAGE || "message"}</pre>
          <pre>{process.env.REACT_APP_GIT_DATE || "date"}</pre>
        </Space>
      </Header>
    </Layout>
  );
}
